import React from "react";
import { Link } from "react-router-dom";
import "./CSS/privacy-policy.css";

const sections = [
  {
    title: "Information We Collect",
    items: [
      "Account details such as name, phone number, email address, role, and login credentials.",
      "Business details such as bunk/station name, location, and operational settings.",
      "Transaction and reporting data such as credits, payments, reconciliation, passbook, expenses, stock, and related records.",
      "Device and usage data needed to keep the app working properly, such as logs, app version, and device information.",
    ],
  },
  {
    title: "How We Use Information",
    items: [
      "Provide FuelFlow services and authenticate users.",
      "Store and display operational, financial, and reporting data.",
      "Support reconciliation, passbook, customer credit, and admin workflows.",
      "Improve performance, reliability, and usability.",
      "Respond to support requests and maintain records required for business or legal purposes.",
    ],
  },
  {
    title: "Sharing Of Information",
    items: [
      "We do not sell personal information.",
      "Information may be shared with authorized users within your organization.",
      "We may also share limited data with service providers who help us host or support the app.",
      "We may disclose information when required by law or to protect rights, safety, or prevent fraud.",
    ],
  },
  {
    title: "Data Retention And Security",
    items: [
      "We keep data only as long as needed to provide the service and meet legal or business requirements.",
      "We use reasonable security practices to protect data from unauthorized access, loss, misuse, or disclosure.",
      "No system is completely secure, but we work to keep your information protected.",
    ],
  },
  {
    title: "Children",
    items: [
      "FuelFlow is not intended for children under 13.",
      "We do not knowingly collect personal information from children under 13.",
      "If we discover that such information was collected, we will take steps to delete it.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <main className="privacy-policy-page">
      <section className="privacy-hero">
        <div className="privacy-hero-copy">
          <p className="privacy-eyebrow">FuelFlow Privacy Policy</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-lead">
            This policy explains how FuelFlow handles user and business data across the app,
            web platform, and related services.
          </p>
        </div>

        <div className="privacy-hero-card">
          <div>
            <strong>Contact</strong>
            <p className="mb-0">fuelflow.in@gmail.com</p>
            <p className="mb-0">https://fuelflow.in</p>
          </div>
          <div>
            <strong>Last updated</strong>
            <p className="mb-0">9 June 2026</p>
          </div>
        </div>
      </section>

      <section className="privacy-content">
        {sections.map((section) => (
          <article className="privacy-card" key={section.title}>
            <h2>{section.title}</h2>
            <ul>
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}

        <article className="privacy-card">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or your data, contact us at{" "}
            <a href="mailto:fuelflow.in@gmail.com">fuelflow.in@gmail.com</a> or visit{" "}
            <a href="https://fuelflow.in" target="_blank" rel="noreferrer">
              https://fuelflow.in
            </a>
            .
          </p>
          <p className="mb-0">
            You can also return to the <Link to="/">FuelFlow login</Link>.
          </p>
        </article>
      </section>
    </main>
  );
}
